import Vue from 'vue'
import Router from 'vue-router'
import Fields from './pages/Fields'
import Orders from './pages/Orders'
import Order from './pages/Order'
import Login from './pages/Login'
import Signup from './pages/Signup'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'orders',
      component: Orders,
      meta: { requiresAuth: true }
    },
    {
      path: '/fields',
      name: 'fields',
      component: Fields,
      meta: { requiresAuth: true }
    },
    {
      path: '/orders/:id',
      name: 'orders',
      component: Order,
      meta: { requiresAuth: true }
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ],
  mode: 'history'
})
